/* DONAVELLO — dnv-filter-fix.js
   DÜZELTME 69 — Filtre panelindeki KATEGORİ pillerinde
   (Ana Yemekler / Atıştırmalıklar / Salatalar / İçecekler)
   bir kategori seçiliyken diğerine geçmek için önce eski
   seçimi elle kapatmak gerekiyordu.
   Kök neden: assets/collection.js'teki native tıklama mantığı
   (fillterTagEvents) "şu an başka bir etiket işaretli mi"
   kontrolünü checkbox'ın checked durumuna bakarak yapıyor,
   ama checkbox'ın checked durumu yalnızca sunucudan gelen
   AJAX yanıtı sayfayı yeniden çizdiğinde güncelleniyor — o da
   $('.filter-blocks').replaceWith(...) çağrısı bu temadaki
   gerçek sarmalayıcı sınıfla (.filter-tag) eşleşmiyor, yani
   hiçbir zaman tetiklenmiyor. Sonuç: tıklanan pilin görünür
   ".active" durumu ile checkbox'ın gerçek "checked" durumu
   birbirinden kopuyor, native mantık kafası karışıp ikinci
   kategoriyi reddediyor.

   DÜZELTME 70 — DÜZELTME 69'un YAN ETKİSİ: "tik kalkıyor ama
   yeni kategori gelmiyor"
   Kök neden: aşağıdaki kural capture aşamasında (native
   handler'dan ÖNCE) eski pilin checkbox'ını "checked=false"
   yapıyordu. Ama assets/collection.js'teki native kod, eski
   etiketi Shopify.queryParams.constraint'ten (URL filtre
   parametresi) SİLMEK için tam olarak "başka bir checkbox hâlâ
   checked mi" kontrolüne bakıyor — checkbox'ı native'den ÖNCE
   biz kapatınca, native hiçbir checked checkbox bulamıyor ve
   eski etiketi constraint'ten çıkarma adımını atlıyor. Sonuç:
   yeni tıklanan etiket eskisinin ÜZERİNE ekleniyor (constraint
   "ana-yemek+icecek" gibi iki etiketin VE'si oluyor), bu da
   hiçbir ürünle eşleşmediği için yeni kategori hiç gelmiyor.
   Çözüm: checkbox'ı kapatmakla YETİNMEYİP, eski etiketin
   değerini Shopify.queryParams.constraint'ten de biz siliyoruz
   — native kod bir sonraki adımda constraint'i baştan okuyunca
   eski etiketi zaten bulamıyor ve sadece yeni etiketi ekliyor. */
document.addEventListener('click', function(e){
  var link = e.target.closest('.wg-list-tags a, .list-tag a');
  if (!link || link.classList.contains('clear')) return;
  var group = link.closest('.wg-list-tags, .list-tag');
  if (!group) return;
  var wasActive = link.classList.contains('active');
  if (wasActive) return;
  group.querySelectorAll('a.active').forEach(function(other){
    if (other === link) return;
    other.classList.remove('active');
    var cb = other.previousElementSibling;
    if (!cb || cb.tagName !== 'INPUT' || cb.type !== 'checkbox') return;
    var tagValue = cb.value;
    cb.checked = false;
    if (tagValue && window.Shopify && Shopify.queryParams && Shopify.queryParams.constraint) {
      var tags = Shopify.queryParams.constraint.split('+');
      var pos = tags.indexOf(tagValue);
      if (pos >= 0) {
        tags.splice(pos, 1);
        if (tags.length) {
          Shopify.queryParams.constraint = tags.join('+');
        } else {
          delete Shopify.queryParams.constraint;
        }
      }
    }
  });
}, true);
